import React, { Component } from 'react';
import { Row, Col, Typography, Divider } from "antd";
import { OnBoardingNav } from '../../Components/Navigation/OnBoardingNav';
import  Footer  from "../Footer/Footer"
import "./Blogs.css";



const { Title } = Typography;


class BlogPost extends Component {
 constructor(props) {
    super(props);
    this.state = {
      mainArticle: props.article,
      relatedArticles: [],
    };
 }

 componentDidMount(){
    window.scrollTo(0, 0)
 }

 render() {
    const { mainArticle, relatedArticles } = this.state;

    return (
<>
    <Col>
        <Row>
            <div style={{width: '100vw'}}>
            <OnBoardingNav/>

            </div>
        </Row>
        <Row>
            <Col span={4}></Col>
            <Col span={16}>

            <iframe 
                src={mainArticle} 
                style={{display:'block', width:'100%', height: '250vh'}}
                frameborder="0"
                allowfullscreen="true"
                seamless
                // scrolling="no"
            ></iframe>
            </Col>
            <Col span={4}>
                <Row style={{marginTop: '4em'}}> 
                <Title level={3} underline>Related Articles</Title>

                </Row>

                {relatedArticles.slice(0, 5).map(article => {
                    return (
                        <Row> Title 1
                            {/* <a href={`/blog/${article.id}`}>{article.title}</a> */}
                        </Row>

                    )
                })}

                <Row> More coming soon...
                </Row>
                


            </Col>
        </Row>
        </Col>
        <Footer />

      </>
    );
 }
}

export default BlogPost;